// Elementor announces a successful submission only through a jQuery event, so the
// appended message element is watched instead.
export const initFormSuccess = () => {
  document.querySelectorAll<HTMLFormElement>(".elementor-form").forEach((form) => {
    const observer = new MutationObserver(() => {
      const message = form.querySelector<HTMLElement>(".elementor-message-success");

      if (!message) return;

      observer.disconnect();
      form.classList.add("wfg-form-submitted");

      // The submit button carries the focus and is hidden along with the fields.
      message.tabIndex = -1;
      message.focus({ preventScroll: true });

      const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      message.scrollIntoView({ behavior: reduceMotion ? "auto" : "smooth", block: "center" });
    });

    observer.observe(form, { childList: true });
  });
};
